<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3 d-flex justify-content-between">
      <div class="font20">Company Structure Setup</div>
    </div>

    <div class="row">
      <div class="col-lg-3 col-sm-12 vertical-nav my-3">
        <div class="bg-white border-radius px-2">
          <div class="nav flex-column nav-pills vertical-nav" id="v-pills-tab" role="tablist"
            aria-orientation="vertical">
            <a class="nav-link active" id="v-pills-Department-tab" data-toggle="pill" href="#v-pills-Department"
              role="tab" aria-controls="v-pills-Department" aria-selected="true">Department</a>
            <a class="nav-link" data-toggle="pill" href="#v-pills-Designation">Designation</a>

            <a class="nav-link" data-toggle="pill" href="#v-pills-Division">Division</a>
            <a class="nav-link" data-toggle="pill" href="#v-pills-Unit">Unit</a>
          </div>
        </div>
      </div>
      <div class="col-lg-9 col-sm-12 my-3">
        <div class="bg-white border-radius py-4">
          <div class="tab-content" id="v-pills-tabContent">
            <!-- <div
              class="tab-pane fade "
              id="v-pills-Tiers"
              role="tabpanel"
              aria-labelledby="v-pills-Tiers-tab"
            >
              <div>
                <div
                  class="justify-content-between d-flex px-3 align-items-center"
                >
                  <h5 class="font18">Tiers</h5>
                  <div>
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      data-toggle="modal"
                      data-target="#addModal"
                    >
                      Add Tier
                    </button>
                  </div>
                </div>
                <hr />
                <div class="px-3">
                  <div
                    class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        src="assets/images/menu-icon.png"
                        alt=""
                        class="mr-3"
                      />
                      <div>Department</div>
                    </div>
                    <div>
                      <img src="assets/images/close.png" alt="" />
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        src="assets/images/menu-icon.png"
                        alt=""
                        class="mr-3"
                      />
                      <div>Division</div>
                    </div>
                    <div>
                      <img src="assets/images/close.png" alt="" />
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        src="assets/images/menu-icon.png"
                        alt=""
                        class="mr-3"
                      />
                      <div>Unit</div>
                    </div>
                    <div>
                      <img src="assets/images/close.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="tab-pane fade show active" id="v-pills-Department" role="tabpanel"
              aria-labelledby="v-pills-Department-tab">
              <div>
                <div class="justify-content-between d-flex px-3 align-items-center">
                  <h5 class="font18">Department</h5>
                  <div>
                    <button class="btn btn-outline-secondary btn-sm" data-toggle="modal"
                      data-target="#addDepartmentModal">
                      Add Department
                    </button>
                  </div>
                </div>
                <hr />
                <div class="px-3" *ngIf="departments.length == 0">
                  <p>There are no departments yet, try creating some.</p>
                </div>

                <div class="px-3 d-flex justify-content-end" *ngIf="isDeleting">
                  <mat-spinner diameter="20"></mat-spinner>
                </div>

                <div *ngFor="let department of departments">
                  <div class="px-3">
                    <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                      <div class="d-flex align-items-center">
                        <img src="assets/images/menu-icon.png" alt="" class="mr-3" />
                        <div>{{ department?.name }}</div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div class="click" (click)="editDepartment(department)" data-toggle="modal"
                          data-target="#addDepartmentModal">
                          <img src="assets/icons/edit.png" alt="" />
                        </div>

                        <div class="click ml-2" (click)="deleteDepartment(department)">
                          <img src="assets/images/close.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-Designation" role="tabpanel"
              aria-labelledby="v-pills-Designation-tab">
              <div>
                <div class="justify-content-between d-flex px-3 align-items-center">
                  <h5 class="font18">Designation</h5>
                  <div>
                    <button class="btn btn-outline-secondary btn-sm" data-toggle="modal"
                      data-target="#addDesignationModal">
                      Add Designation
                    </button>
                  </div>
                </div>
                <hr />
                <div class="px-3" *ngIf="designations.length == 0">
                  <p>There are no designations yet, try creating some.</p>
                </div>

                <div class="px-3 d-flex justify-content-end" *ngIf="isDeleting">
                  <mat-spinner diameter="20"></mat-spinner>
                </div>

                <div *ngFor="let designation of designations">
                  <div class="px-3">
                    <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                      <div class="d-flex align-items-center">
                        <img src="assets/images/menu-icon.png" alt="" class="mr-3" />
                        <div>{{ designation?.name }}</div>
                      </div>

                      <div class="d-flex align-items-center">
                        <div class="click" (click)="editDesignation(designation)" data-toggle="modal"
                          data-target="#addDesignationModal">
                          <img src="assets/icons/edit.png" alt="" />
                        </div>

                        <div class="click ml-2" (click)="deleteDesignation(designation)">
                          <img src="assets/images/close.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-GradeLevel" role="tabpanel" aria-labelledby="v-pills-GradeLevel-tab">
              <div>
                <div class="justify-content-between d-flex px-3 align-items-center">
                  <h5 class="font18">Grade Level</h5>
                  <div>
                    <button class="btn btn-outline-secondary btn-sm" data-toggle="modal" data-target="#addModal">
                      Add Grade Level
                    </button>
                  </div>
                </div>
                <hr />
                <div class="px-3">
                  <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                    <div class="d-flex align-items-center">
                      <img src="assets/images/menu-icon.png" alt="" class="mr-3" />
                      <div>Chiefs</div>
                    </div>
                    <div>
                      <img src="assets/images/close.png" alt="" />
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                    <div class="d-flex align-items-center">
                      <img src="assets/images/menu-icon.png" alt="" class="mr-3" />
                      <div>Directors</div>
                    </div>
                    <div>
                      <img src="assets/images/close.png" alt="" />
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                    <div class="d-flex align-items-center">
                      <img src="assets/images/menu-icon.png" alt="" class="mr-3" />
                      <div>Heads of Department</div>
                    </div>
                    <div>
                      <img src="assets/images/close.png" alt="" />
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                    <div class="d-flex align-items-center">
                      <img src="assets/images/menu-icon.png" alt="" class="mr-3" />
                      <div>Managers</div>
                    </div>
                    <div>
                      <img src="assets/images/close.png" alt="" />
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                    <div class="d-flex align-items-center">
                      <img src="assets/images/menu-icon.png" alt="" class="mr-3" />
                      <div>Associates</div>
                    </div>
                    <div>
                      <img src="assets/images/close.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-Unit" role="tabpanel" aria-labelledby="v-pills-Unit-tab">
              <div>
                <div class="justify-content-between d-flex px-3 align-items-center">
                  <h5 class="font18">Unit</h5>
                  <div>
                    <button class="btn btn-outline-secondary btn-sm" data-toggle="modal" data-target="#addUnitModal">
                      Add Unit
                    </button>
                  </div>
                </div>
                <hr />
                <div class="px-3" *ngIf="units.length == 0">
                  <p>There are no units yet, try creating some.</p>
                </div>
                <div class="px-3">
                  <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3"
                    *ngFor="let unit of units">
                    <div class="d-flex align-items-center">
                      <img src="assets/images/menu-icon.png" alt="" class="mr-3" />
                      <div>{{ unit?.name }}</div>
                    </div>
                    <div class="click" (click)="deleteUnit(unit)">
                      <img src="assets/images/close.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-Division" role="tabpanel" aria-labelledby="v-pills-Division-tab">
              <div>
                <div class="justify-content-between d-flex px-3 align-items-center">
                  <h5 class="font18">Division</h5>
                  <div>
                    <button class="btn btn-outline-secondary btn-sm" data-toggle="modal"
                      data-target="#addDivisionModal">
                      Add Division
                    </button>
                  </div>
                </div>
                <hr />
                <div class="px-3" *ngIf="divisions.length == 0">
                  <p>There are no divisions yet, try creating some.</p>
                </div>
                <div class="px-3">
                  <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3"
                    *ngFor="let division of divisions">
                    <div class="d-flex align-items-center">
                      <img src="assets/images/menu-icon.png" alt="" class="mr-3" />
                      <div>{{ division?.name }}</div>
                    </div>

                    <div class="d-flex align-items-center">
                      <!-- <div
                        class="click"
                        (click)="editDivision(division)"
                        data-toggle="modal"
                        data-target="#addDivisionModal"
                      >
                        <img src="assets/icons/edit.png" alt="" />
                      </div> -->

                      <div class="click ml-2" (click)="deleteDivision(division)">
                        <img src="assets/images/close.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="v-pills-group" role="tabpanel" aria-labelledby="v-pills-group-tab">
              <div class="justify-content-between d-flex px-3 align-items-center">
                <h5 class="font18">Unit</h5>
                <div>
                  <button class="btn btn-outline-secondary btn-sm" data-toggle="modal" data-target="#addUnitModal">
                    Add Unit
                  </button>
                </div>
              </div>
              <hr />
              <div class="px-3">
                <div class="row">
                  <div class="col-lg-6 col-sm-12 my-2">
                    <div class="p-4 d-flex align-items-center border-radius bg-grey">
                      <div class="profile mr-3">
                        <img src="assets/icons/people.png" alt="" />
                      </div>
                      <div>
                        <p class="mb-1 font-bold">TrailBlazers</p>
                        <p class="mb-0 text-grey font14">10 Members</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>

<!-- Modal -->

<app-modal elementId="addDepartmentModal"
  [headerTitle]="this.selectedDepartment ? 'Update Department' : 'Add Department'" centered="true" [styles]="{
    modalBodyHeight: '180px',
    modalContentWidth: '421px'
  }">
  <div class="content">
    <hr class="hline" />
    <div class="form-row mt-5">
      <div class="d-flex justify-content-center mb-4 form-group">
        <input type="text" class="text-start form-control" placeholder="Enter Department Name"
          [(ngModel)]="departmentForm" [ngClass]="{
            'is-invalid': !departmentForm
          }" />
        <span class="text-danger">*</span>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <button data-dismiss="modal" (click)="addDepartment()" class="modalBtn btn-primary" type="button"
        [disabled]="!departmentForm">
        {{ this.selectedDepartment ? 'Update' : 'Add' }} Department
      </button>
    </div>
  </div>
</app-modal>

<app-modal elementId="addDesignationModal" [headerTitle]="
    this.selectedDesignation ? 'Update Designation' : 'Add Designation'
  " centered="true" [styles]="{
    modalBodyHeight: '180px',
    modalContentWidth: '421px'
  }">
  <div class="content">
    <hr class="hline" />
    <div class="form-row mt-5">
      <div class="d-flex justify-content-center mb-4 form-group">
        <input type="text" class="text-start form-control" placeholder="Enter Designation Name"
          [(ngModel)]="designationForm" [ngClass]="{
            'is-invalid': !designationForm
          }" />
        <span class="text-danger">*</span>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <button data-dismiss="modal" (click)="addDesignation()" class="modalBtn btn-primary" type="button"
        [disabled]="!designationForm">
        {{ this.selectedDesignation ? 'Update' : 'Add' }} Designation
      </button>
    </div>
  </div>
</app-modal>

<app-modal elementId="addDivisionModal" headerTitle="Add Division" centered="true" [styles]="{
    modalBodyHeight: '220px',
    modalContentWidth: '421px'
  }">
  <div class="content">
    <hr class="hline" />
    <form action="" class="" [formGroup]="divisionForm">
      <div class="form-row">
        <div class="d-flex justify-content-center mt-5 mb-4 form-group">
          <select class="form-control" formControlName="departmentId">
            <option value="" disabled>--Select Department--</option>
            <option value="{{ department?.id }}" *ngFor="let department of departments">
              {{ department?.name }}
            </option>
          </select>
          <span class="text-danger">*</span>
        </div>
      </div>
      <div class="form-row">
        <div class="d-flex justify-content-center mb-4 form-group">
          <input type="text" class="text-start form-control" placeholder="Enter Division Name"
            formControlName="nameOnlyRequestDTOS" [ngClass]="{
              'is-invalid':
                divisionForm.get('nameOnlyRequestDTOS').errors &&
                divisionForm.get('nameOnlyRequestDTOS').touched
            }" />
          <span class="text-danger">*</span>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <button data-dismiss="modal" (click)="addDivision()" class="modalBtn btn-secondary" type="button"
          [disabled]="divisionForm.invalid">
          Add Division
        </button>
      </div>
    </form>
  </div>
</app-modal>

<app-modal elementId="addUnitModal" headerTitle="Add Unit" centered="true" [styles]="{
    modalBodyHeight: '220px',
    modalContentWidth: '421px'
  }">
  <div class="content">
    <hr class="hline" />
    <form action="" class="" [formGroup]="unitForm">
      <div class="form-row">
        <div class="d-flex justify-content-center mt-5 mb-4 form-group">
          <select class="form-control" formControlName="divisionId">
            <option value="" disabled>--Select Division--</option>
            <option value="{{ division?.id }}" *ngFor="let division of divisions">
              {{ division?.name }}
            </option>
          </select>
          <span class="text-danger">*</span>
        </div>
      </div>
      <div class="form-row">
        <div class="d-flex justify-content-center mb-4 form-group">
          <input type="text" class="text-start form-control" placeholder="Enter Unit Name"
            formControlName="nameOnlyRequestDTOS" [ngClass]="{
              'is-invalid':
                unitForm.get('nameOnlyRequestDTOS').errors &&
                unitForm.get('nameOnlyRequestDTOS').touched
            }" />
          <span class="text-danger">*</span>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <button data-dismiss="modal" (click)="addUnit()" class="modalBtn btn-primary" type="button"
          [disabled]="unitForm.invalid">
          Add Unit
        </button>
      </div>
    </form>
  </div>
</app-modal>
<!-- Modal -->

<!-- delete Modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="d-flex justify-content-between p-4">
        <h5 class="modal-title" id="deleteModalLabel">Confirm Delete</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="font-light px-5">
          Are you sure you want to delete this Department? Click the "No" button
          to cancel this action
        </p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-secondary bg-white btn-outline-secondary" data-dismiss="modal">
          No
        </button>
        <button type="button" class="btn btn-secondary">Yes</button>
      </div>
    </div>
  </div>
</div>